if (!customElements.get('statutory-guarantee')) {
  customElements.define('statutory-guarantee', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const section = this.closest('.shopify-section') || this.parentElement;
      section.querySelectorAll('[data-statutory-guarantee]').forEach(link => {
        if (link.dataset.statutoryGuarantee !== this.dialog.id) return;
        link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.opener = link;
          this.dialog.showModal();
          this.previousOverflow = documentElement().style.overflow;
          documentElement().style.overflow = 'hidden';
        }, options);
      });
      this.querySelector('.statutory-guarantee-close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const first = this.querySelector('.statutory-guarantee-close');
        const last = this.querySelector('.statutory-guarantee-help a');
        if (event.shiftKey && window.document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && window.document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        documentElement().style.overflow = this.previousOverflow || '';
        if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
      function documentElement() { return window.document.documentElement; }
    }
    disconnectedCallback() {
      if (this.dialog && this.dialog.open) {
        window.document.documentElement.style.overflow = this.previousOverflow || '';
        this.dialog.close();
      }
      if (this.controller) this.controller.abort();
    }
  });
}
